import { ReactElement } from 'react';
import { useMatch } from 'react-router-dom';

import { CatalogHeader } from './CatalogHeader';
import { Categories } from './Categories';
import { ServicesList } from './ServicesList';
import styles from './styles.module.scss';
import { useCategoriesApi, useServicesApi } from './useCatalogApi';

import { BrowserTitle, AnalyticsTrackPageView } from ':components';

export function CatalogPage(): ReactElement {
  const match = useMatch('/catalog/:categoryId');
  const categoryId = match?.params['categoryId'];
  const {
    data: categories,
    isLoading: categoriesLoading,
    isError: categoriesError,
    refetch: refetchCategories,
  } = useCategoriesApi();
  const {
    data: services,
    isLoading: servicesLoading,
    isError: servicesError,
    refetch: refetchServices,
  } = useServicesApi(categoryId);

  return (
    <div className={styles.mainContainer}>
      <BrowserTitle title='Каталог сервисов' />
      <AnalyticsTrackPageView />
      <div className={styles.catalogContainer}>
        <CatalogHeader isLoading={categoriesLoading && servicesLoading} />
        <Categories
          items={categories?.items}
          isLoading={categoriesLoading}
          error={categoriesError}
          paramsCategoryId={categoryId}
          refetch={refetchCategories}
        />
        <ServicesList
          items={services?.items}
          isLoading={servicesLoading}
          error={servicesError}
          refetch={refetchServices}
        />
      </div>
    </div>
  );
}
